// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"a4daee41","833":"18e5ece7"}[chunkId] + ".chunk.js";
};